import { ListFilesRequestContent, ListFilesResponseContent } from "@equaliq/api-model";
import { createApiRequest } from "../common";

/**
 * API function to list files
 * @param request Optional filters for listing files
 * @returns Promise with list of files
 */
export const listFilesApi = async (request?: ListFilesRequestContent): Promise<ListFilesResponseContent> => {
  const apiRequest = createApiRequest<ListFilesResponseContent>('post', '/files/list');
  return apiRequest(request || {});
};
